var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyramid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_125_780)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 735",
    d: "M5.53125 14.75L7.84375 1.21875L1 11.875L5.53125 14.75Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 311",
    d: "M5.92084 3.88614L3.24758 8.37129L0.90625 11.9688L2.125 12.6485L5.4375 14.7812L7.76243 14.3438L11.3125 13.599L14.0312 12.6485H15.1288L12.5446 8.22277L10.2872 5.07426L7.76243 0.5L5.92084 3.88614Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 309",
    d: "M0.9375 11.875L7.78888 1.1875L14.8096 12.3304L5.71875 14.9375L0.9375 11.875Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 734",
    d: "M7.78125 1.5L5.5625 14.6875",
    stroke: "black",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramid);
export default __webpack_public_path__ + "static/media/pyramid.8dc475f00cb84f6ab81f1505ed551351.svg";
export { ForwardRef as ReactComponent };